<ng-container *ngIf="operationDayNotes">
  <p class="small-text color-darkgrey" id="operation">{{ operationDayNotes }}.</p>
</ng-container>

<ng-container *ngIf="lastConfirmedDate">
  <p i18n class="small-text color-darkgrey mt-12" id="date">Last updated on <strong>{{ lastConfirmedDate | date:'medium' }}</strong>.</p>
</ng-container>

<p i18n class="small-text color-darkgrey">*EVSE Ports details and availability are subject to change.</p>
